<template>
  <div class="container">
    <div class="background-container">
      <div v-for="(image, index) in backgroundImages" :key="index" class="image-wrapper">
        <el-image :src="image" class="background-image" fit="contain"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundImages: [
        require('@/assets/images/res1.gif'),
        require('@/assets/images/res2.gif'),
        require('@/assets/images/res3.gif'),
        require('@/assets/images/res4.gif'),
        require('@/assets/images/res5.gif'),
        require('@/assets/images/res6.gif'),
        require('@/assets/images/res7.gif'),
        require('@/assets/images/res8.gif'),
        require('@/assets/images/res9.gif'),
        require('@/assets/images/res10.gif'),
      ],
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.background-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image-wrapper {
  width: 100%;
  height: auto; /* 允许高度根据图片比例自动调整 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片按比例缩放且完整展示 */
}

@media screen and (max-width: 768px) {
  .background-image {
    width: 100%;
    height: auto;
    object-fit: contain; /* 在小屏幕上按比例缩放 */
  }
}
</style>
